export const pageUrls = {
  accommodationFunnel: '/travel/accommodation/',
  flightCheckout: '/travel/#redirect_flight_checkout/',
  hotelHomePage: '/frontend-home/hotels',
  resultsPage: 'hotel_results',
} as const;
